document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-buy-now');

  if (!btn) return;

  const form = btn.closest('form');

  if (!form) return;

  // Submit the product form (adds the selected variant)
  form.requestSubmit();

  // Go to checkout after a short delay
  setTimeout(() => {
    window.location.href = '/checkout';
  }, 500);
});